import React, { useCallback } from 'react';
import Dropzone from 'react-dropzone';
import { useToast } from '../../../hooks/useToast';
import styles from './Droppable.module.scss';

export type DroppableProps = {
	handleDrop: ( acceptedFiles: File[] ) => void;
	acceptedFilesTypes: string;
	className?: string;
	content: React.ReactNode;
};

export const Droppable: React.FC<DroppableProps> = ( {
	handleDrop,
	acceptedFilesTypes,
	className,
	content,
} ) => {
	const { showError } = useToast();
	const onDrop = useCallback(
		( acceptedFiles: File[] ) => {
			if ( acceptedFiles.length ) {
				handleDrop( acceptedFiles );
			} else {
				showError( 'Oops! Please upload a valid image file.' );
			}
		},
		[ handleDrop, showError ]
	);

	return (
		<Dropzone onDrop={ onDrop } accept={ acceptedFilesTypes }>
			{ ( { getRootProps, getInputProps, isDragActive } ) => (
				<div
					{ ...getRootProps() }
					className={ `${ styles.root } ${
						isDragActive ? styles.active : ''
					} dropzone ${ isDragActive ? 'dropzone--isActive' : '' }` }
				>
					<div className={ `${ styles.zone } ${ className || '' }` }>
						{ content }
						<input { ...getInputProps() } />
					</div>
				</div>
			) }
		</Dropzone>
	);
};
